import { useCallback } from "react";

import { fetchJson } from "@sprint1/pkg/src/fetch/fetchJson";
import { useFetchJsonAsync } from "@sprint1/pkg/src/fetch/useFetchJsonAsync";
//__convertToQueryString__ import { convertToQueryString } from "@sprint1/pkg/src/url/convertToQueryString";


import { GetSiteSurveyLinkResponse } from "api/types/getSiteSurveyLinkResponse";
import { AssignToTechnicianRequest } from "api/types/assignToTechnicianRequest";

export function getSiteSurveyLink(arg: GetSiteSurveyLinkArgType) {
  //__queryString__
  return fetchJson<GetSiteSurveyLinkResponse>(`/api/SiteSurvey/SiteSurveyLink`, {
    method: "POST",
    body: arg.request,
  });
}

export function useGetSiteSurveyLink(arg?: UseGetSiteSurveyLinkArgType) {
  const { run, ...rest } = useFetchJsonAsync({
    runOnMount: arg?.runOnMount,
    asyncFn: arg?.runOnMount ? () => getSiteSurveyLink(arg) : undefined,
  });

  const getSiteSurveyLinkCb = useCallback(
    (arg: GetSiteSurveyLinkArgType) => {
      return run(() => getSiteSurveyLink(arg));
    },
    [run]
  );
  return {
    ...rest,
    getSiteSurveyLink: getSiteSurveyLinkCb,
    siteSurveyLink: rest?.fetchJsonResponse?.data,
  };
}

export interface GetSiteSurveyLinkArgType {
  request: AssignToTechnicianRequest;
}

export type UseGetSiteSurveyLinkArgType =
  | { runOnMount: false }
  | ({ runOnMount: true } & GetSiteSurveyLinkArgType);

